var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSativaIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Sativa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Sativa",
    stroke: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(3.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12,0.545454545 L12,4.90909091",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,23.4545455 L12,19.0909091",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4545455,12 L19.0909091,12",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.545454545,12 L4.90909091,12",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7272727,2.08007265 L15.5454545,5.85909259",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27272727,21.9199274 L8.45454545,18.1409074",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9199274,17.7272727 L18.1409074,15.5454545",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08007265,6.27272727 L5.85909259,8.45454545",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9199274,6.27272727 L18.1409074,8.45454545",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.08007265,17.7272727 L5.85909259,15.5454545",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7272727,21.9199274 L15.5454545,18.1409074",
    id: "Line"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.27272727,2.08007265 L8.45454545,5.85909259",
    id: "Line-Copy"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12,18.5454545 C15.6149547,18.5454545 18.5454545,15.6149547 18.5454545,12 C18.5454545,8.38504527 15.6149547,5.45454545 12,5.45454545 C8.38504527,5.45454545 5.45454545,8.38504527 5.45454545,12 C5.45454545,15.6149547 8.38504527,18.5454545 12,18.5454545 Z",
    id: "Oval-2"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSativaIcon);
export default __webpack_public_path__ + "static/media/sativaIcon.a8c300bbe2f52270bd542ebab4c4b5ab.svg";
export { ForwardRef as ReactComponent };